module.exports = __webpack_public_path__ + "static/media/fly0105.0763d990.webp";